import { combineReducers } from "redux";

import appReducer from "./reducers/cashBookingReducer";
import manifestReducer from "./reducers/manifestReducer";
import masterReducer from "./reducers/masterReducer";
import onboardingReducer from "./reducers/onboardingReducer";
import hubReconciliationReducer from "./reducers/hubReconciliationReducer";

const appReducers = combineReducers({
  appReducer,
  manifestReducer,
  masterReducer,
  onboardingReducer,
  hubReconciliationReducer,
});

export default appReducers;
